var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btndefault-container",class:_vm.rootClassName},[_c('button',{staticClass:"btndefault-btnsee-more-button",attrs:{"disabled":_vm.isDisabled}},[_c('span',{staticClass:"btndefault-text"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }